module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"TURO","short_name":"TURO","start_url":"/","background_color":"#eebf4f","theme_color":"#eebf4f","display":"minimal-ui","icon":"src/images/turo-logo.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"7b0361513cbdd165306a4743c0048451"},
    },{
      plugin: require('../node_modules/gatsby-plugin-gatsby-cloud/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-react-i18next/gatsby-browser.js'),
      options: {"plugins":[],"localeJsonSourceName":"translations","languages":["pl"],"defaultLanguage":"pl","i18nextOptions":{"keySeparator":"."},"pages":[{"matchPath":"(.*)","languages":["pl"]}]},
    },{
      plugin: require('../node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":-108},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
